import View from "components/layout/view";
import AdminListTemplatesTable from "./table";
import Title from "components/title";

const AdminListTemplatesView = () => {
  return (
    <View title="Luettelomallit" description="">
      <Title>Luettelomallit</Title>
      <AdminListTemplatesTable />
    </View>
  );
};

export default AdminListTemplatesView;
